const API_BASE_URL_KEY = 'admin.targetOverride.apiBaseUrl';
const MERCURE_URL_KEY = 'admin.targetOverride.mercureUrl';

function normalize(value: string): string {
  return value.trim().replace(/\/$/, '');
}

function read(key: string): string | null {
  if (typeof window === 'undefined') return null;

  return window.sessionStorage.getItem(key) || null;
}

function write(key: string, value: string): void {
  window.sessionStorage.setItem(key, normalize(value));
}

function clear(key: string): void {
  window.sessionStorage.removeItem(key);
}

export function getApiBaseUrlOverride(): string | null {
  return read(API_BASE_URL_KEY);
}

export function setApiBaseUrlOverride(value: string): void {
  write(API_BASE_URL_KEY, value);
}

export function clearApiBaseUrlOverride(): void {
  clear(API_BASE_URL_KEY);
}

export function getMercureUrlOverride(): string | null {
  return read(MERCURE_URL_KEY);
}

export function setMercureUrlOverride(value: string): void {
  write(MERCURE_URL_KEY, value);
}

export function clearMercureUrlOverride(): void {
  clear(MERCURE_URL_KEY);
}

export function getEffectiveApiBaseUrl(defaultValue: string): string {
  return getApiBaseUrlOverride() || defaultValue;
}

export function getEffectiveMercureUrl(defaultValue: string): string {
  return getMercureUrlOverride() || defaultValue;
}

export function hasActiveOverride(): boolean {
  return null !== getApiBaseUrlOverride() || null !== getMercureUrlOverride();
}
